import React from 'react'
import { useAboutTemplate } from '../../hooks/useAboutTemplate'
import PageTitle from '../../components/PageTitle';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

const About = () => {
    useAboutTemplate();
  return (
    <>
    <PageTitle title="About Us" />
    <AboutSection />
    <ContactSection />
    </>
  )
}

export default About